import React from "react";
import { Link } from "react-router-dom";
import { Trophy, ChevronRight } from "lucide-react";

export function WinnersBanner({ className = "" }) {
  return (
    <Link to="/winners" data-testid="winners-banner"
      className={`group relative flex items-center gap-3 overflow-hidden rounded-2xl bg-gradient-to-r from-gold-600/30 via-gold-500/15 to-transparent px-4 py-3 ring-1 ring-gold-500/40 transition-colors hover:ring-gold-400 ${className}`}>
      <span className="winners-shine absolute inset-0" aria-hidden="true" />
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-500 text-navy-950"><Trophy size={18} /></span>
      <span className="min-w-0 flex-1 text-left">
        <span className="block font-display text-[16px] font-extrabold leading-tight text-white">The winners are in</span>
        <span className="block truncate text-[12px] text-gold-200">Meet the 6 teams who took the stage</span>
      </span>
      <ChevronRight size={20} className="shrink-0 text-gold-400 transition-transform group-hover:translate-x-1" />
    </Link>
  );
}
